import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const GraphqlFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GraphqlFile",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.12 10.14q-.12-.165-.27-.3l-7.53-7.49q-.12-.12-.24-.21c-.14-.08-.3-.12-.47-.13H8.98a4.21 4.21 0 0 0-4.21 4.15v20.12c0 2.2 1.73 3.73 4.21 3.73h14.03c2.47 0 4.21-1.53 4.21-3.73V10.84c.03-.24 0-.47-.1-.69Zm-2.75 16.13c0 .76-.76.97-1.4.97H8.98c-.64 0-1.4-.18-1.4-.97V6.15c0-.77.63-1.4 1.4-1.4h7.95v5.14c0 1.29 1.03 2.33 2.32 2.34h5.13v14.04Zm-7.19-12.51c.04-.11.06-.22.07-.34a1.261 1.261 0 0 0-2.52 0c0 .12.03.23.07.34l-2.92 1.69c-.23-.25-.56-.39-.9-.39-.68.02-1.23.57-1.23 1.26 0 .58.41 1.07.97 1.19v3.4c-.56.12-.97.62-.97 1.2 0 .69.56 1.25 1.25 1.25.34 0 .67-.14.9-.39l2.92 1.7c-.23.66.12 1.37.78 1.6s1.37-.12 1.6-.78c.09-.26.09-.55 0-.82l2.92-1.7c.23.25.56.39.9.39.69 0 1.25-.55 1.26-1.24 0-.58-.41-1.08-.97-1.2v-3.4c.56-.12.97-.61.97-1.19 0-.69-.56-1.26-1.26-1.26-.34 0-.67.14-.9.39l-2.95-1.69Zm2.64 2.22c-.04.11-.07.22-.07.34 0 .58.41 1.07.97 1.19v3.4l-3.8-6.6 2.89 1.67Zm0 5.85h-7.65c-.05-.23-.16-.44-.33-.6l3.81-6.6c.22.09.46.09.68 0l3.81 6.6c-.17.16-.28.37-.33.6Zm-4.73-7.52-3.8 6.6v-3.4c.56-.12.97-.61.97-1.19 0-.12-.03-.23-.07-.34l2.89-1.67Zm1.81 9.85c-.23-.25-.56-.39-.91-.39-.34 0-.67.14-.91.39l-2.92-1.69v-.05h7.64v.05z"
    })
  }));
};